export default {
  data() {
    return {
      headers: [
        { text: 'Тип', align: 'left', value: 'type' },
        { text: 'Дата создания',
          align: 'right _date',
          value: 'created_at',
          sort: (a, b) => {
            let array = a.split(' ');
            let array2 = array[0].split('.');
            array2[1] -= 1;
            let array3 = array[1].split(':');
            const dtA = new Date(array2[2], array2[1], array2[0], array3[0], array3[1], array3[2]);
            array = b.split(' ');
            array2 = array[0].split('.');
            array2[1] -= 1;
            array3 = array[1].split(':');
            const dtB = new Date(array2[2], array2[1], array2[0], array3[0], array3[1], array3[2]);
            return dtA - dtB;
          },
        },
        { text: 'Сумма', align: 'right', value: 'amount' },
        { text: 'Дата сгорания',
          align: 'right _date',
          value: 'combustion_at',
          sort: (a, b) => {
            let array = a.split(' ');
            let array2 = array[0].split('.');
            array2[1] -= 1;
            let array3 = array[1].split(':');
            const dtA = new Date(array2[2], array2[1], array2[0], array3[0], array3[1], array3[2]);
            array = b.split(' ');
            array2 = array[0].split('.');
            array2[1] -= 1;
            array3 = array[1].split(':');
            const dtB = new Date(array2[2], array2[1], array2[0], array3[0], array3[1], array3[2]);
            return dtA - dtB;
          },
        },
        { text: 'Название', align: 'right', value: 'title' },
      ],
      rowsPerPageItems: [
        50, 100, 250, { text: 'Весь список', value: -1 },
      ],
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    loading() {
      return this.$store.state.loading;
    },
    transactions() {
      const { userTransactions } = this.$store.state;
      return userTransactions.map(item => ({
        type: item.type,
        created_at: item.created_at,
        amount: item.amount,
        combustion_at: item.combustion_at,
        title: item.title,
      }));
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    userCanMakeTransaction() {
      return this.user && this.user.can_make_transaction;
    },
    userCanMakeTransactionReason() {
      return this.user && this.user.can_make_transaction_reason;
    },
  },
  methods: {
    getTypeLabel(type) {
      return type === 'in'
        ? { label: 'Входящая', color: 'green' }
        : { label: 'Исходящая', color: 'red' };
    },
  },
  mounted() {
    this.$store.dispatch('GetProfile');
    this.$store.dispatch('GetTransactions');
  },
};
